import ImpactsOnStakeholdersFormProvider, {
  useImpactsOnStakeholdersForm,
} from './ImpactsOnStakeholdersFormProvider';

export { useImpactsOnStakeholdersForm };
export default ImpactsOnStakeholdersFormProvider;
